<template>
  <div class="container">
    <div id="home_top" class="header">
      <div v-if="show_school" style="width: 100%;">
        <el-row>
          <el-col :span="4" v-if="show_school">
            <div style="margin-top: 16px; margin-left: 5px; text-align:left">
              <el-select style="min-width: 180px" size="mini" v-model="Select_School" collapse-tags placeholder="请选择" @change="handleChangeSchool">
                <el-option v-for="item in school_list" :key="item.id" :label="item.campusName" :value="item.dept_id">
                </el-option>
              </el-select>
            </div>
          </el-col>

          <el-col :span="14">
            <div>
              <div class="fl mar">
                <el-menu class="el-menu-demo" mode="horizontal" text-color="white" active-text-color="white" @select="handleSelect1">
                  <el-menu-item index="1"><i style="font-size: 14px; font-weight: bold; color: white" class="el-icon-arrow-left"></i>返回首页</el-menu-item>

                  <el-menu-item v-if="classroom_show" index="2">我的教室</el-menu-item>
                </el-menu>
              </div>
            </div>
          </el-col>

          <el-col :span="6">
            <div>
              <el-row v-if="$store.getters.username">
                <el-col :span="18" style="white-space: nowrap;text-overflow: ellipsis;">
                  <div style="text-align: right">
                    <!-- 我的教室添加icon -->
                    <span v-if="schoolanagement_show" @click="GotoSchool">
                      <el-badge style="margin-right: 10px">
                        <!-- <i
                              style="margin-right: 0px;font-size: 18px; border-radius: 15px; color: #666666;cursor: pointer; padding:4px;background-color:white; ">
                            </i> -->
                        <div style="width: 24px;height: 24px;background-color: #fff;border-radius: 50%;padding-top: 3px;cursor: pointer;box-sizing: border-box;margin-top: -3px;">
                          <div style="width: 18px;height: 18px;margin-left: 3px;">
                            <svg t="1712728449571" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5083" width="18" height="18">
                              <path d="M949.333333 424.533333h-874.666666c-12.8 0-23.466667-8.533333-29.866667-19.2-4.266667-12.8-2.133333-25.6 6.4-36.266666l149.333333-166.4c12.8-12.8 32-14.933333 44.8-2.133334 12.8 12.8 12.8 34.133333 2.133334 46.933334L149.333333 356.266667h802.133334c17.066667 0 32 14.933333 32 34.133333-2.133333 19.2-17.066667 34.133333-34.133334 34.133333zM74.666667 599.466667h874.666666c12.8 0 23.466667 8.533333 29.866667 19.2 4.266667 12.8 2.133333 25.6-6.4 36.266666l-149.333333 166.4c-12.8 12.8-32 14.933333-44.8 2.133334-12.8-12.8-12.8-34.133333-2.133334-46.933334l98.133334-108.8H74.666667c-17.066667 0-32-14.933333-32-34.133333 0-19.2 14.933333-34.133333 32-34.133333z" fill="#3876F6" p-id="5084"></path>
                            </svg>
                          </div>
                        </div>
                        <!-- <span style="width: 18px;height: 18px;"> -->

                        <!-- <svg t="1712728449571" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                xmlns="http://www.w3.org/2000/svg" p-id="5083" width="18" height="18">
                                <path
                                  d="M949.333333 424.533333h-874.666666c-12.8 0-23.466667-8.533333-29.866667-19.2-4.266667-12.8-2.133333-25.6 6.4-36.266666l149.333333-166.4c12.8-12.8 32-14.933333 44.8-2.133334 12.8 12.8 12.8 34.133333 2.133334 46.933334L149.333333 356.266667h802.133334c17.066667 0 32 14.933333 32 34.133333-2.133333 19.2-17.066667 34.133333-34.133334 34.133333zM74.666667 599.466667h874.666666c12.8 0 23.466667 8.533333 29.866667 19.2 4.266667 12.8 2.133333 25.6-6.4 36.266666l-149.333333 166.4c-12.8 12.8-32 14.933333-44.8 2.133334-12.8-12.8-12.8-34.133333-2.133334-46.933334l98.133334-108.8H74.666667c-17.066667 0-32-14.933333-32-34.133333 0-19.2 14.933333-34.133333 32-34.133333z"
                                  fill="#3876F6" p-id="5084"></path>
                              </svg> -->
                        <!-- </span> -->
                      </el-badge>
                    </span>
                    <span @click="GotoSchool" style="color:#fff;margin-right:20px;font-size: 12px;cursor: pointer;" v-if="schoolanagement_show">校区管理</span>
                    <span v-if="$store.state.user.schoolInfo.adminNoticeAuth">
                      <span v-if="$store.state.user.userInfo.noticeAuth">
                        <el-badge :value="notice_nolook > 0 ? notice_nolook : null" style="margin-right: 20px">
                          <i style="
                                                  margin-right: 0px;
                                                  font-size: 24px;
                                                  color: white;
                                                  cursor: pointer;
                                                " class="el-icon-message-solid" @click="LookNotices"></i>
                        </el-badge>
                        <span style="vertical-align:middle;margin-right:15px;">
                          <el-tooltip class="item" effect="dark" content="帮助中心" placement="bottom">
                            <a href="https://help.steam.fun" target="_blank">
                              <img src="@/assets/image/help.png" alt="" style="width:18px;border-radius:50%;">
                            </a>
                          </el-tooltip>
                        </span>
                      </span>
                    </span>
                    <span style="line-height: 60px; color: white; font-size: 16px" @click="drawer = true">欢迎 ,
                    </span>

                    <span style="
                                                line-height: 60px;
                                                color: white;
                                                font-size: 16px;
                                                font-weight: bold;
                                                margin-right: 20px;
                                              " v-if="$store.state.user.identity === 2" class="username">{{
                        $store.state.user.userInfo.stuUserInfo.realName
                      }}</span>

                    <el-tooltip v-else class="item" effect="dark" :content="$store.state.user.userInfo.realName" placement="bottom">
                      <span style="max-width:64px;line-height: 60px;color: white;font-size: 16px;font-weight: bold; display: inline-block;white-space: nowrap;overflow: hidden;vertical-align: top;text-overflow: ellipsis;" class="username">
                        <!-- {{ $store.state.user.userInfo.realName.slice(0, 4) }} -->
                        {{ $store.state.user.userInfo.realName }}</span>
                    </el-tooltip>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div style="text-align: center">
                    <el-dropdown>
                      <el-avatar style="
                                                  margin-top: 12px;
                                                  border: 1px solid white;
                                                " size="medium" :src="
                          $store.state.user.userInfo.userImageUrl
                            ? $store.state.user.userInfo.userImageUrl
                            : $store.state.user.userInfo.headimgUrl
                        "></el-avatar>

                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="classroom_show">
                          <router-link :to="{ name: 'classroomIndex' }" tag="li">我的教室</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="classroomstu_show">
                          <router-link :to="{ name: 'code-classroom-stu' }" tag="li">我的教室</router-link>
                        </el-dropdown-item>

                        <el-dropdown-item v-if="community_show">
                          <router-link :to="{ name: 'community-home' }" tag="li">作品社区</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="schoolanagement_show">
                          <span @click="GotoSchool" tag="li">校区管理</span>
                        </el-dropdown-item>
                        <el-dropdown-item divided>
                          <userinfo></userinfo>
                        </el-dropdown-item>

                        <el-dropdown-item>
                          <passward></passward>
                        </el-dropdown-item>

                        <el-dropdown-item divided v-if="is_principal">
                          <schoolinfo></schoolinfo>
                        </el-dropdown-item>

                        <el-dropdown-item divided @click.native="layout">退出登录</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>

      <div id="header_other" v-else style="width: 100%;">
        <el-row>
          <el-col :span="4">
            <div>
              <div class="header-logo">
                <el-image v-if="school_logo" @click="$router.push({ path: '/' })" class="header-logo-img" :src="
                    school_logo +
                      '?x-oss-process=image/resize,m_pad,h_100,w_300'
                  "></el-image>
              </div>
            </div>
          </el-col>

          <!--
            <el-col :span="4"
              ><div style="height: 40px">
                <span
                  style="
                    margin-left: 20px;
                    line-height: 60px;
                    color: white;
                    cursor: pointer;
                    font-size: 16px;
                  "
                  @click="$router.push({ path: '/' })"
                  >STEAM.FUN</span
                >
              </div></el-col
            >
  -->
          <el-col :span="8" v-if="show_school" class="not-mobile-hidden">
            <div style="margin-top: 6px">
              <el-select size="mini" v-model="Select_School" multiple collapse-tags="true" placeholder="请选择">
                <el-option v-for="item in school_list" :key="item.id" :label="item.campusName" :value="item.dept_id">
                </el-option>
              </el-select>
            </div>
          </el-col>

          <el-col :span="14" v-if="!show_school" class="not-mobile-hidden">
            <div>
              <div class="fl mar" v-if="show_home">
                <el-menu class="el-menu-demo" mode="horizontal" text-color="white" active-text-color="white" @select="handleSelect">
                  <el-menu-item index="1" class="mobile-hidden">首页</el-menu-item>
                  <el-menu-item v-if="classroom_show || classroomstu_show" index="5">我的教室</el-menu-item>
                  <el-menu-item index="6" v-if="$store.state.user.userInfo.zoneAuth && $store.state.user.schoolInfo.stuZoneAuth">作品社区</el-menu-item>
                  <el-menu-item index="6" v-if="this.$store.state.user.identity === 1">作品社区</el-menu-item>
                  <!-- 教师端根据 question_bank_show_type 字段判断用新老赛区，学生只用模拟测评 1旧版 2新版-->
                  <!-- 学生的 -->
                  <el-menu-item index="7" v-if="
                      $store.state.user.schoolInfo.questionBankPermission && classroomstu_show &&
                            $store.state.user.userInfo.testAuth && $store.state.user.userInfo.stuUserInfo 
                    ">
                    <!-- 模拟测评 -->
                    赛考中心
                  </el-menu-item>
                  <!-- 教师的 questionBankShowType:1是老校区，2是新校区 -->
                  <el-menu-item v-if="
                      $store.state.user.schoolInfo.questionBankPermission &&
                        !$store.state.user.userInfo.stuUserInfo 
                    " index="13">赛考中心</el-menu-item>

                  <el-menu-item index="10" v-if="
                      $store.state.user.schoolInfo.ojPermission &&
                        ($store.state.user.userInfo.ojPermission ||
                          (classroomstu_show &&
                            $store.state.user.userInfo.ojAuth))
                    ">
                    <!-- v-if="
                      $store.state.user.schoolInfo.ojPermission &&
                        (classroom_show ||
                          (classroomstu_show &&
                            $store.state.user.userInfo.ojAuth)) || $store.state.user.userInfo.ojPermission
                    " -->
                    信奥专区
                  </el-menu-item>

                  <el-menu-item index="8" class="mobile-hidden">下载</el-menu-item>
                  <el-menu-item index="11" v-if="self_header_button[0]">
                    <a :href="self_header_button[0].link" target="_blank" style="vertical-align:initial">
                      {{ self_header_button[0].name }}
                    </a>
                  </el-menu-item>
                  <el-menu-item index="12" v-if="self_header_button[1]">
                    <a :href="self_header_button[1].link" target="_blank" style="vertical-align:initial">
                      {{ self_header_button[1].name }}
                    </a>
                  </el-menu-item>

                  <!--
                  <el-menu-item v-if="
                    schoolanagement_show &&
                    (classroom_show || classroomstu_show)
                  " index="9">
                    校区管理</el-menu-item>
-->
                </el-menu>
              </div>
            </div>
          </el-col>

          <el-col v-if="show_home" :span="6" class="not-mobile-hidden">
            <div>
              <el-row v-if="$store.getters.username">
                <el-col :span="18" style="white-space: nowrap;text-overflow: ellipsis;">
                  <div style="text-align: right">
                    <span v-if="schoolanagement_show" @click="GotoSchool">
                      <el-badge style="margin-right:10px">
                        <!-- <i style="margin-right: 0px;font-size: 18px; border-radius: 15px; color: #666666;cursor: pointer; padding:4px;background-color:white; "
                          class="el-icon-school"></i> -->
                        <div style="width: 24px;height: 24px;background-color: #fff;border-radius: 50%;padding-top: 3px;cursor: pointer;box-sizing: border-box;margin-top: -3px;">
                          <div style="width: 18px;height: 18px;margin-left: 3px;">
                            <div style="float: left;">
                              <svg t="1712728449571" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5083" width="18" height="18">
                                <path d="M949.333333 424.533333h-874.666666c-12.8 0-23.466667-8.533333-29.866667-19.2-4.266667-12.8-2.133333-25.6 6.4-36.266666l149.333333-166.4c12.8-12.8 32-14.933333 44.8-2.133334 12.8 12.8 12.8 34.133333 2.133334 46.933334L149.333333 356.266667h802.133334c17.066667 0 32 14.933333 32 34.133333-2.133333 19.2-17.066667 34.133333-34.133334 34.133333zM74.666667 599.466667h874.666666c12.8 0 23.466667 8.533333 29.866667 19.2 4.266667 12.8 2.133333 25.6-6.4 36.266666l-149.333333 166.4c-12.8 12.8-32 14.933333-44.8 2.133334-12.8-12.8-12.8-34.133333-2.133334-46.933334l98.133334-108.8H74.666667c-17.066667 0-32-14.933333-32-34.133333 0-19.2 14.933333-34.133333 32-34.133333z" fill="#3876F6" p-id="5084"></path>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </el-badge>
                    </span>
                    <span @click="GotoSchool" style="color:#fff;margin-right:20px;font-size: 12px;cursor: pointer;" v-if="schoolanagement_show">校区管理</span>

                    <span v-if="$store.state.user.schoolInfo.adminNoticeAuth">
                      <span v-if="$store.state.user.userInfo.noticeAuth">
                        <el-badge :value="notice_nolook > 0 ? notice_nolook : null" style="margin-right: 20px">
                          <i style="
                                                  margin-right: 0px;
                                                  font-size: 24px;
                                                  color: white;
                                                  cursor: pointer;
                                                " class="el-icon-message-solid" @click="LookNotices"></i>
                        </el-badge>
                        <span style="vertical-align:middle;margin-right:15px;">
                          <el-tooltip class="item" effect="dark" content="帮助中心" placement="bottom">
                            <a href="https://help.steam.fun" target="_blank">
                              <img src="@/assets/image/help.png" alt="" style="width:18px;border-radius:50%;">
                            </a>
                          </el-tooltip>
                        </span>
                      </span>
                    </span>
                    <span style="line-height: 60px; color: white; font-size: 16px" @click="drawer = true">欢迎 ,
                    </span>
                    <span style="line-height: 60px;color: white; font-size: 16px;font-weight: bold;" v-if="$store.state.user.identity === 2" class="username">
                      {{
                        $store.state.user.userInfo.stuUserInfo.realName
                      }}</span>
                    <el-tooltip v-else class="item" effect="dark" :content="$store.state.user.userInfo.realName" placement="bottom">
                      <span style="max-width:64px;line-height: 60px;color: white;font-size: 16px;font-weight: bold; display: inline-block;white-space: nowrap;overflow: hidden;vertical-align: top;text-overflow: ellipsis;" class="username">
                        <!-- {{ $store.state.user.userInfo.realName.slice(0, 4) }} -->
                        {{ $store.state.user.userInfo.realName }}
                      </span>
                    </el-tooltip>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div style="text-align: center">
                    <el-dropdown>
                      <el-avatar style="margin-top: 12px; border: 1px solid white" size="medium" :src="
                          $store.state.user.userInfo.userImageUrl
                            ? $store.state.user.userInfo.userImageUrl
                            : $store.state.user.userInfo.headimgUrl
                        "></el-avatar>

                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="classroom_show">
                          <router-link :to="{ name: 'classroomIndex' }" tag="li">我的教室</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="classroomstu_show">
                          <router-link :to="{ name: 'code-classroom-stu' }" tag="li">我的教室</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="community_show">
                          <!-- <router-link :to="{ name: 'community-home' }" tag="li"
                              >作品社区1</router-link
                            > -->
                          <router-link :to="{ name: 'community-home' }" tag="li" v-if="$store.state.user.userInfo.zoneAuth && $store.state.user.schoolInfo.stuZoneAuth">作品社区</router-link>
                          <router-link :to="{ name: 'community-home' }" tag="li" v-if="this.$store.state.user.identity === 1">作品社区</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="schoolanagement_show">
                          <span @click="GotoSchool" tag="li">校区管理</span>
                        </el-dropdown-item>

                        <el-dropdown-item divided>
                          <userinfo></userinfo>
                        </el-dropdown-item>

                        <el-dropdown-item>
                          <passward></passward>
                        </el-dropdown-item>

                        <el-dropdown-item divided v-if="is_principal">
                          <schoolinfo></schoolinfo>
                        </el-dropdown-item>

                        <el-dropdown-item divided @click.native="layout">退出登录</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </el-col>
              </el-row>

              <el-row v-if="true">
                <el-col :span="24">
                  <div style="text-align: right">
                    <span style="
                                                line-height: 60px;
                                                color: white;
                                                font-size: 14px;
                                                margin-right: 20px;
                                                cursor: pointer;
                                                border: 1px solid white;
                                                padding: 10px;
                                                border-radius: 10px;
                                              " v-if="!$store.getters.username" @click="login">登录入口</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>

          <el-col v-if="!show_home" :span="4" :offset="16" class="not-mobile-hidden">
            <div>
              <el-row v-if="$store.getters.username">
                <el-col :span="16">
                  <div style="text-align: right">
                    <span style="line-height: 60px; color: white; font-size: 16px" @click="drawer = true">欢迎 ,
                    </span>

                    <span style="
                                                line-height: 60px;
                                                color: white;
                                                font-size: 16px;
                                                font-weight: bold;
                                              " v-if="$store.state.user.identity === 2" class="username">{{
                        $store.state.user.userInfo.stuUserInfo.realName
                      }}</span>

                    <span style="
                                                margin-left: 5px;
                                                line-height: 60px;
                                                color: white;
                                                font-size: 16px;
                                                font-weight: bold;
                                              " v-else class="username">{{
                        $store.state.user.userInfo.realName.slice(0, 4)
                      }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div style="text-align: center">
                    <el-dropdown>
                      <el-avatar style="margin-top: 12px; border: 1px solid white" size="medium" :src="
                          $store.state.user.userInfo.userImageUrl
                            ? $store.state.user.userInfo.userImageUrl
                            : $store.state.user.userInfo.headimgUrl
                        "></el-avatar>

                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="classroom_show">
                          <router-link :to="{ name: 'classroomIndex' }" tag="li">我的教室</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="classroomstu_show">
                          <router-link :to="{ name: 'code-classroom-stu' }" tag="li">我的教室</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="community_show">
                          <router-link :to="{ name: 'community-home' }" tag="li">作品社区</router-link>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="schoolanagement_show">
                          <span @click="GotoSchool" tag="li">校区管理</span>
                        </el-dropdown-item>

                        <el-dropdown-item divided>
                          <userinfo></userinfo>
                        </el-dropdown-item>

                        <el-dropdown-item>
                          <passward></passward>
                        </el-dropdown-item>

                        <el-dropdown-item divided v-if="is_principal">
                          <schoolinfo></schoolinfo>
                        </el-dropdown-item>

                        <el-dropdown-item divided @click.native="layout">退出登录</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </el-col>
              </el-row>

              <el-row v-if="true">
                <el-col :span="24">
                  <div style="text-align: right">
                    <span style="
                                                line-height: 60px;
                                                color: white;
                                                font-size: 14px;
                                                margin-right: 20px;
                                                cursor: pointer;
                                                border: 1px solid white;
                                                padding: 10px;
                                                border-radius: 10px;
                                              " v-if="!$store.getters.username" @click="login">登录入口</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>

      <div id="home_bottom" class="header-menu-container">
        <div class="header-menu-container-area"></div>
      </div>
    </div>

    <template v-if="$route.path.startsWith('/school-home-page')">
      <router-view v-if="Select_School" :key="Select_School" />
    </template>
    <router-view v-else />
    <!--修改账号信息-->

    <el-dialog title="帮助中心-新增学员" :visible.sync="dialogVisible" width="80%" top="5vh" append-to-body>
      <div>
        <iframe style="width: 100%; height: 80vh" :src="helpurl"></iframe>
      </div>
    </el-dialog>

    <div v-if="$store.state.user.schoolInfo.adminNoticeAuth">
      <div v-if="$store.state.user.userInfo.noticeAuth">
        <el-dialog custom-class="notice_show" :title="notice_form.title" :visible.sync="dialogVisible1" width="50%" :show-close="false" :close-on-click-modal="false">
          <div style="max-height: 50vh; overflow-y: scroll" v-html="notice_form.content"></div>
          <span slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="updateNoticeIsReatState">知道了</el-button>
          </span>
        </el-dialog>
      </div>
    </div>

    <el-drawer title="系统消息" :visible.sync="drawer" :direction="direction" size="50%">
      <div class="notice_css">
        <el-timeline style="margin: 10px">
          <el-timeline-item v-for="item in noticeUserList" :key="item.id" :timestamp="item.noticeInfo.created_time" placement="top">
            <el-card style="margin: 10px">
              <div slot="header" class="clearfix">
                <span>{{ item.noticeInfo.title }}</span>
                <el-button v-if="item.is_read" style="float: right; padding: 3px 0; color: grey" type="text" disabled>已读
                </el-button>

                <el-button v-else style="float: right; padding: 3px 0" type="text" @click="SignNoticeState(item)">标为已读
                </el-button>
              </div>

              <p v-html="item.noticeInfo.content"></p>
            </el-card>
          </el-timeline-item>
        </el-timeline>

        <div style="margin: 20px; text-align: center">
          <el-pagination @current-change="handleCurrentChange" :current-page="page_no" :page-size="page_size" layout="total,prev, pager, next" :total="total"></el-pagination>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getUserCampusList,
  testSchoolQustionBankAuth,
  getTchNoticeList,
  updateNoticeIsReatState,
  tesSchoolOjAuth,
  getTchRecentNotReadNotice,
} from '@/api/educational.js'
import userinfo from '@/components/userinfo'
import passward from '@/components/passward'
import schoolinfo from '@/components/schoolinfo'
import { getHomepage } from '@/api/homeset'
import Bus from '@/common/bus'

export default {
  name: 'index',
  data() {
    return {
      homepage: [],
      self_header_button: [],
      theme: '',
      hoverColor: '',
      is_principal: false, //超级管理员
      header_show: false,
      home_show: false,
      classroom_show: false, //我的教室
      classroomstu_show: false, //学生我的教室
      preparelesson_show: false, //备课中心
      community_show: false, //编程社区
      schoolanagement_show: false, //学校管理
      props: { multiple: true },
      school_list: [], //校区列表
      Select_School: null, //所选校区
      show_school: false,
      show_home: false,

      show_info: false,
      helpurl:
        'https://huewq7h021.feishu.cn/docs/doccnE4GYWDhl73g6V6b90sejzd#PUfocY',
      dialogVisible: false,

      school_logo: '',
      has_questionbank: false,
      has_questionbank1: false,

      has_notice: false, //老师账号显示通知
      notice_nolook: 0,
      dialogVisible1: false, //通知显示框
      notice_form: {
        noticeUserId: '',
        title: '',
        content: '',
      },
      drawer: false,
      direction: 'ltr',
      noticeUserList: [], //通知列表
      page_no: 1,
      page_size: 20,
      total: 0,
    }
  },

  components: { userinfo, passward, schoolinfo },

  computed: {
    cssColor() {
      return {
        '--color': this.$store.state.theme.theme,
      }
    },
  },
  watch: {
    // '$route.path'(val) {
    //   console.log(val, 123456)
    //   if (val == '/') {
    //     if (this.$store.state.user.identity == "1") {
    //       this.has_notice = true;
    //       this.getTchRecentNotReadNotice();
    //     }
    //   }

    // },
    '$store.state.theme.theme'(val) {
      this.hoverColor = val
      console.log(this.hoverColor, 4545)
    },
    Select_School(newV, oldV) {
      console.log(
        '全局默认校区:key,--------------------------------------oldV:',
        oldV,
        'newV:',
        newV
      )
      console.log(this.Select_School)
      this.$store.commit('SET_SELECTSCHOOL', [this.Select_School])
    },

    $route: {
      async handler(val, oldval) {
        console.log(val, 666) //新路由信息
        console.log(oldval, 666) //老路由信息
        this.$store.commit('SET_STOREROUTE', this.$route)
        if (val.name == 'community-home') {
          console.log('进入社区')
          document.getElementById('home_top').style.display = 'none'
        } else if (val.name == 'dataBoard') {
          console.log('进入学校管理')
          document.getElementById('home_top').style.display = 'block'
          document.getElementById('home_bottom').style.display = 'none'
        } else if (val.name == 'prepare-lessons') {
          console.log('进入备课中心')
          document.getElementById('home_top').style.display = 'block'
          document.getElementById('home_bottom').style.display = 'none'
        } else if (val.name == 'home') {
          console.log('返回主站')
          document.getElementById('home_top').style.display = 'block'
          document.getElementById('home_bottom').style.display = 'block'
        } else if (val.fullPath.indexOf('/competitionCenter') === 0) {
          console.log('进入赛事中心')
          document.getElementById('home_top').style.display = 'none'
          console.log(document.getElementById('home_top').style.display)
        }
        // 如果是从其它页面进入的校区管理页面,再去重新调用校区列表
        if (
          val.path.startsWith('/school-home-page') &&
          !oldval.path.startsWith('/school-home-page')
        ) {
          await this.getUserCampusList()
        }
        // // 路由必须有name，并且不是超管端才调用
        // if (val.name && !val.fullPath.includes('/background/')) {
        //   this.$store.dispatch('getStuTitleUrl')
        // }
      },
      // 深度观察监听
      deep: true,
    },
    '$store.state.user.roleList': {
      handler() {
        // console.log(
        //   '%c 输出的roleList信息： ',
        //   'background:#f00;color:white',
        //   val,
        //   old
        // )
        const roleList = this.$store.getters.roleList
        const is_principal = this.$store.getters.is_principal
        this.header_show = false
        this.home_show = false
        this.classroom_show = false
        this.preparelesson_show = false //备课中心
        this.community_show = false //编程社区
        this.schoolanagement_show = false //学校管理
        if (is_principal) {
          this.is_principal = true
          this.header_show = true
          this.home_show = true
          // this.classroom_show = true // 超管没有教师身份也不能看我的教室
          this.preparelesson_show = true //备课中心
          this.community_show = true //编程社区
          this.schoolanagement_show = true //学校管理

          for (let i = 0; i < roleList.length; i++) {
            if (roleList[i] === 2) {
              //教师
              this.classroom_show = true
            }
          }
        } else {
          if (roleList) {
            console.log(roleList, 454545)
            this.schoolanagement_show = true

            for (let i = 0; i < roleList.length; i++) {
              console.log(roleList[i])
              if (roleList[i] === 5) {
                //管理员
                this.header_show = true
                this.home_show = true
                this.community_show = true
                this.schoolanagement_show = true
              } else if (roleList[i] === 1) {
                //校长
                this.header_show = true
                this.home_show = true
                this.community_show = true
                this.schoolanagement_show = true
              } else if (roleList[i] === 2) {
                //教师
                this.header_show = true
                this.home_show = true
                this.classroom_show = true
                this.preparelesson_show = true
                this.community_show = true
                this.schoolanagement_show = true
              } else if (roleList[i] === 3) {
                //教务
                this.header_show = true
                this.home_show = true
                this.community_show = true
                this.schoolanagement_show = true
                console.log('教务')
              } else if (roleList[i] === 4) {
                //销售
                this.header_show = true
                this.home_show = true
                this.community_show = true
                this.schoolanagement_show = true
                console.log('销售')
              } else if (roleList[i] === '财务') {
                this.header_show = true
                this.home_show = true
                this.schoolanagement_show = true
                console.log('财务')
              } else if (roleList[i] === 6) {
                //前台
                this.header_show = true
                this.home_show = true
                this.community_show = true
                this.schoolanagement_show = true
                console.log('前台')
              }
            }
          } else {
            console.log(roleList, 454545)

            this.header_show = true
            this.home_show = true
            console.log('学生')
            this.classroomstu_show = true
            this.community_show = true
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },

  async mounted() {
    this.$store.commit('SET_STOREROUTE', this.$route)
    if (this.$route.path.indexOf('school') >= 0) {
      this.show_school = true
      this.show_home = true
      console.log('学校管理控制为true')
    } else {
      if (this.$route.path.indexOf('classroom') >= 0) {
        console.log('学校管理控制为false')
        this.show_school = false
        this.show_home = true
      } else {
        console.log('学校管理控制为false')
        this.show_school = false
        this.show_home = true
      }
    }

    if (JSON.parse(sessionStorage.getItem('schoolInfo')) === null) {
      //获得校区LOGO信息
      getHomepage().then((res) => {
        console.log('校区LOGO')
        console.log(res)
        if (res.homepageData) {
          console.log('有校区LOGO')
          this.homepage = res.homepageData.homepage
          if (res.homepageData.homepage.self_header_button) {
            this.self_header_button =
              res.homepageData.homepage.self_header_button
          }
          this.school_logo = res.homepageData.homepage.logo_img_url
          this.theme = res.schoolInfo.theme_color
          this.$store.commit('themeName', this.theme)
          sessionStorage.setItem('schoolInfo', JSON.stringify(res))
          sessionStorage.setItem('homepage', this.homepage.is_show_copy_right)
          console.log(sessionStorage.getItem('homepage'), 45215)
        }
      })
    } else {
      console.log(JSON.parse(sessionStorage.getItem('schoolInfo')), 789456143)
      if (
        JSON.parse(sessionStorage.getItem('schoolInfo')).homepageData.homepage
          .self_header_button
      ) {
        this.self_header_button = JSON.parse(
          sessionStorage.getItem('schoolInfo')
        ).homepageData.homepage.self_header_button
      }

      this.school_logo = JSON.parse(
        sessionStorage.getItem('schoolInfo')
      ).homepageData.homepage.logo_img_url
      this.theme = JSON.parse(
        sessionStorage.getItem('schoolInfo')
      ).schoolInfo.theme_color
      this.$store.commit('themeName', this.theme)
    }

    if (this.$store.state.user.token) {
      console.log('用户已登陆')
      await this.getUserCampusList()

      //检测是否有通知
      if (this.$store.state.user.identity == '1') {
        this.has_notice = true
        this.notice_nolook = sessionStorage.getItem('notReadNum')
      }
    }
    console.log(this.$route, 2125487845)

    if (this.$route.path == '/') {
      console.log('位于首页')
      if (this.$store.state.user.identity == '1') {
        this.has_notice = true
        this.getTchRecentNotReadNotice()
      }
      window.onscroll = function () {
        var navbar = document.querySelector('.header')
        if (window.pageYOffset > 0) {
          navbar.classList.add('sticky')
        } else {
          navbar.classList.remove('sticky')
        }
      }
    }
    Bus.$on('UpdateUserCampusList', () => {
      this.UpdateUserCampusList()
    })
  },

  updated() {
    var navbar = document.querySelector('.header')
    console.log('this.$route.path:', this.$route.path)
    if (!navbar) return false
    if (this.$route.path.indexOf('school') >= 0) {
      this.show_school = true
      this.show_home = true
      console.log('位于学校管理')
      navbar.classList.remove('sticky')
      navbar.classList.add('nomal')
      navbar.style.backgroundColor = this.$store.state.theme.theme
    } else if (
      this.$route.path.indexOf('classroom') >= 0 ||
      (this.$route.path.indexOf('exam') >= 0 &&
        this.$route.path.indexOf('commonExam') === -1) ||
      this.$route.path.indexOf('oj') >= 0 ||
      this.$route.path.indexOf('download') >= 0 ||
      this.$route.path.indexOf('teachingAndResearchTraining') >= 0
    ) {
      this.show_school = false
      this.show_home = true
      navbar.style.display = 'block'
      console.log('位于我的教室,模拟测评,信奥专区,下载,师资培训,试卷管理编辑')
      navbar.classList.remove('sticky')
      navbar.classList.add('nomal')
      navbar.style.backgroundColor = this.$store.state.theme.theme
    } else if (this.$route.path.indexOf('paper') >= 0) {
      this.show_school = false
      this.show_home = true
      navbar.classList.remove('sticky')
      navbar.classList.add('nomal')
      navbar.style.backgroundColor = this.$store.state.theme.theme
    } else if (this.$route.path.indexOf('commonExam') !== -1) {
      navbar.style.display = 'none'
    } else {
      this.show_school = false
      this.show_home = true
      navbar.style.backgroundColor = ''
      navbar.classList.remove('nomal')
      window.onscroll = function () {
        if (window.pageYOffset > 0) {
          navbar.classList.add('sticky')
        } else {
          navbar.classList.remove('sticky')
        }
      }
    }
  },

  methods: {
    getTchRecentNotReadNotice() {
      getTchRecentNotReadNotice({}).then((res) => {
        console.log('通知列表')
        console.log(res, 12454878)
        // this.total = res.total;
        sessionStorage.setItem('notReadNum', res.notReadNum)
        this.notice_nolook = sessionStorage.getItem('notReadNum')
        console.log(res.notReadNum, 123645678)
        let noticeUserList1 = []
        // this.noticeUserList = res.noticeUserList;
        if (res.notReadNotice) {
          noticeUserList1.push(res.notReadNotice)
          console.log(noticeUserList1, 12454878)
          if (noticeUserList1.length > 0) {
            if (!noticeUserList1[0].is_read) {
              console.log('首条消息未读')
              this.notice_form.noticeUserId = noticeUserList1[0].id

              if (noticeUserList1[0].noticeInfo.notice_type == '1') {
                console.log('弹出-仅标题')

                var notice_html = noticeUserList1[0].noticeInfo.content.replace(
                  /<\/?.+?>/g,
                  ''
                )
                var notice = notice_html.replace(/ /g, '') //dds为得到后的内容

                this.$alert(notice, noticeUserList1[0].noticeInfo.title, {
                  confirmButtonText: '知道了',
                  callback: (action) => {
                    console.log('action')
                    console.log(action)
                    if (action == 'confirm') {
                      console.log('已读')
                      this.updateNoticeIsReatState()
                    }
                  },
                })
              } else if (noticeUserList1[0].noticeInfo.notice_type == '2') {
                console.log('弹出-标题及内容')
                this.dialogVisible1 = true
                this.notice_form.title = noticeUserList1[0].noticeInfo.title
                this.notice_form.content = noticeUserList1[0].noticeInfo.content
              }
            }
          }
        }
      })
    },

    //已读消息
    updateNoticeIsReatState() {
      updateNoticeIsReatState({
        noticeUserId: this.notice_form.noticeUserId,
      }).then((res) => {
        console.log('消息标为已读')
        console.log(res)
        if (res.is_update) {
          this.getTchNoticeList()
          this.getTchRecentNotReadNotice()
          this.dialogVisible1 = false
        }
      })
    },

    //标记未读信息
    SignNoticeState(item) {
      this.notice_form.noticeUserId = item.id
      this.updateNoticeIsReatState()
    },
    getTchNoticeList() {
      getTchNoticeList({
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        this.total = res.total
        // this.notice_nolook = res.notReadNum;
        this.noticeUserList = res.noticeUserList
        console.log('查看消息列表')
      })
    },

    //系统消息分页
    handleCurrentChange(val) {
      this.page_no = val
      this.getTchNoticeList()
    },

    //查看消息列表
    LookNotices() {
      getTchNoticeList({
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        this.total = res.total
        // this.notice_nolook = res.notReadNum;
        this.noticeUserList = res.noticeUserList
        console.log('查看消息列表')
        this.drawer = true
      })
    },

    ReloadPage() {
      console.log('刷新网页')
      this.$router.go(0)
    },

    handleSelect(key) {
      console.log(key, 5555)

      if (key == '6') {
        if (this.$store.state.user.identity == '2') {
          this.$store.dispatch('freshUserData').then((res) => {
            console.log(res, 12454)
            if (res.userInfo.zoneAuth === false) {
              this.$message.warning('无权查看')
            } else {
              this.$router.push({
                name: 'community-home',
              })
            }
          })
        } else {
          this.$router.push({
            name: 'community-home',
          })
        }
      } else if (key == '5') {
        if (this.$store.state.user.identity == '2') {
          this.$router.push({ name: 'classroomIndexStu' })
        } else {
          this.$router.push({ name: 'classroomIndex' })
        }
      } else if (key == '4') {
        document.getElementById('teachinfo').scrollIntoView()
      } else if (key == '3') {
        document.getElementById('schoolinfo').scrollIntoView()
      } else if (key == '2') {
        document.getElementById('courseinfo').scrollIntoView()
      } else if (key == '1') {
        this.$router.push({
          name: 'home',
        })
      } else if (key == '7') {
        console.log('测评中心')
        if (this.$store.state.user.identity == '2') {
          this.$store.dispatch('freshUserData').then((res) => {
            console.log(res, 12454)
            if (res.userInfo.testAuth === false) {
              this.$message.warning('无权查看')
            } else {
              this.$router.push({
                name: 'practice-list',
              })
            }
          })
        }
      } else if (key == '8') {
        this.$router.push({
          name: 'download',
        })
      } else if (key == '9') {
        this.$router.push({
          name: 'dataBoard',
        })
      } else if (key == '10') {
        if (this.$store.state.user.identity == '2') {
          this.$store.dispatch('freshUserData').then((res) => {
            console.log(res, 12454)
            if (res.userInfo.ojAuth === false) {
              this.$message.warning('无权查看')
            } else {
              this.$router.push({
                name: 'OJ',
              })
            }
          })
        } else {
          this.$router.push({
            name: 'OJ',
          })
        }
      } else if (key == '13') {
        // 判断进入新老赛考中心：1老2新
        this.$store.dispatch('freshUserData').then(() => {
          if (this.$store.state.user.schoolInfo.questionBankShowType === 1) {
            this.$router.push({
              name: 'platform-question',
            })
          } else {
            this.$router.push({
              name: 'CompetitionCenter-QuestionBankCenter',
            })
          }
        })
      }
    },

    GotoSchool() {
      console.log('当前客户权限表-头像')
      console.log(this.$store.getters.permisionList)

      let name
      if (this.$store.getters.permisionList.length > 0) {
        if (this.$store.getters.permisionList[0].children.length > 0) {
          name = this.$store.getters.permisionList[0].children[0].alias.split(
            ','
          )[0]
        } else {
          name = this.$store.getters.permisionList[1].children[0].alias.split(
            ','
          )[0]
        }
      }

      this.$router.push({
        name: name,
      })
    },

    handleSelect1(key) {
      console.log(key)
      if (key === '1') {
        if (JSON.parse(sessionStorage.getItem('schoolInfo')) === null) {
          //获得校区LOGO信息
          getHomepage().then((res) => {
            console.log('校区LOGO')
            console.log(res)
            if (res.homepageData) {
              console.log('有校区LOGO')
              this.homepage = res.homepageData.homepage
              if (res.homepageData.homepage.self_header_button) {
                this.self_header_button =
                  res.homepageData.homepage.self_header_button
              }
              this.school_logo = res.homepageData.homepage.logo_img_url
              this.theme = res.schoolInfo.theme_color
              this.$store.commit('themeName', this.theme)
              sessionStorage.setItem('schoolInfo', JSON.stringify(res))
              sessionStorage.setItem(
                'homepage',
                this.homepage.is_show_copy_right
              )
              console.log(sessionStorage.getItem('homepage'), 45215)
              this.$router.push({
                name: 'home',
              })
            }
          })
        } else {
          console.log(
            JSON.parse(sessionStorage.getItem('schoolInfo')),
            789456143
          )
          if (
            JSON.parse(sessionStorage.getItem('schoolInfo')).homepageData
              .homepage.self_header_button
          ) {
            this.self_header_button = JSON.parse(
              sessionStorage.getItem('schoolInfo')
            ).homepageData.homepage.self_header_button
          }

          this.school_logo = JSON.parse(
            sessionStorage.getItem('schoolInfo')
          ).homepageData.homepage.logo_img_url
          this.theme = JSON.parse(
            sessionStorage.getItem('schoolInfo')
          ).schoolInfo.theme_color
          this.$store.commit('themeName', this.theme)
          this.$router.push({
            name: 'home',
          })
        }
      } else if (key === '2') {
        this.$router.push({
          name: 'code-classroom',
        })
      } else if (key === '3') {
        this.$router.push({
          name: 'community',
        })
      }
    },

    login() {
      this.$router.push({
        name: 'login',
        isschool: false,
      })
    },
    layout() {
      this.$store.dispatch('LogOut').then(() => {
        sessionStorage.setItem('schoolInfo', null)
        localStorage.removeItem('editor_opentype')
        this.$message.success('退出成功')
        this.$router.push({ path: '/' })
        location.reload()
      })
    },

    //更新所属校区
    UpdateUserCampusList() {
      console.log('更新分校列表')
      getUserCampusList().then((res) => {
        console.log(res)
        this.school_list = res.userDeptList
      })
    },

    //所得账号所负责的校区
    async getUserCampusList() {
      const res = await getUserCampusList()
      console.log('default-index页-获得分校列表')
      console.log(res)
      if (res && res.userDeptList.join('') !== '') {
        this.school_list = res.userDeptList
        if (this.$store.state.user.selected_schools.length > 0 && this.$store.state.user.selected_schools[0]) {
          this.Select_School = this.$store.state.user.selected_schools[0]
        } else {
          this.Select_School = res.userDeptList[0].dept_id
        }
        this.$store.commit('SET_SELECTSCHOOL', [this.Select_School])
        return res
      }
    },
    //显示账号信息
    ShowUserInfo() {
      console.log('显示账号信息')

      this.show_info = !this.show_info
      console.log(this.show_info)
    },

    //文档中心
    HelpCenter() {
      console.log('帮助中心')
      this.dialogVisible = true
    },

    testSchoolQustionBankAuth() {
      testSchoolQustionBankAuth().then((res) => {
        console.log('检测题库权限')
        console.log(res)
        if (res.is_have_auth) {
          this.has_questionbank = true
        } else {
          this.has_questionbank = false
        }
      })
    },
    tesSchoolOjAuth() {
      tesSchoolOjAuth().then((res) => {
        console.log('OJ权限')
        console.log(res, '用户已登陆')
        if (res.is_have_auth) {
          this.has_questionbank1 = true
        } else {
          this.has_questionbank1 = false
        }
      })
    },
    handleChangeSchool(e) {
      console.log(e)
      this.$nextTick(() => {
        Bus.$emit('updateRecord')
      })
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  height: 100%;

  .notice_css {
    overflow-y: scroll;
    height: calc(100vh - 40px);
  }

  .header {
    position: fixed;
    top: 0;
    width: 100%;
    text-align: center;
    z-index: 999;

    .el-menu-demo {
      font-weight: 600;
    }

    .el-menu.el-menu--horizontal {
      border: 0px;
    }

    .header-logo {
      width: 150px;
      height: 50px;
      margin-left: 20px;
      margin-top: 5px;

      .header-logo-img {
        width: 100%;
      }
    }

    .header-container {
      background-color: rgba(78, 92, 108, 1);
      color: #ffffff;

      .header-container-area {
        min-width: 1000px;

        margin: 0 auto;
        font-size: 14px;
        display: flex;
        justify-content: space-between;

        .header-container-area-left {
          margin-left: 20px;
        }

        .header-container-area-right {
          margin-right: 20px;

          .login {
            cursor: pointer;
          }
        }

        .header-container-area-left:hover {
          cursor: pointer;
        }

        .header-container-area-right-content {
          //  margin-right: 20px;

          .username {
            color: rgb(255, 153, 0);
            font-weight: 500;
          }

          .exit {
            cursor: pointer;
            margin-left: 20px;
            margin-right: 20px;
          }
        }

        .message {
          margin-right: 30px;
          padding-right: 10px;
        }
      }
    }

    .header-menu-container {
      .header-menu-container-area {
        padding: 0;
        min-width: 1000px;

        margin: 0 auto;
        overflow: hidden;

        .fl {
          float: left;
          margin-left: 20px;

          .logo {
            width: 120px;
            margin-top: 10px;
          }
        }

        .mar {
          margin-left: 100px;
        }

        .el-menu--horizontal {
          border-bottom: none;
        }
      }
    }
    /deep/ .el-avatar img {
      width: 100%;
    }
  }
}
@import "@/styles/indexMediaStyle.scss";
</style>

<style>
.el-menu-item {
  font-size: 16px;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border: 0px;
}

.el-drawer__header span:focus {
  outline: 0 !important;
}

.el-drawer__header {
  margin-bottom: 0px;
  padding: 0px;
  border-bottom: 0px;
  background: #f9f9f9;
  text-align: center;
}
</style>

<style scoped>
::v-deep .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: var(--color);
  opacity: 0.8;
}

/deep/.el-menu {
  background: none !important;
}

.header.sticky {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.header.nomal {
  position: relative;
  top: 0;
  width: 100%;
  text-align: center;
  z-index: 999;
}
</style>
